module.exports = __webpack_public_path__ + "media/img/frontend_application/stats/icon-bounced-0ecbf3fc114f4b5cc91c55bb0b3337c3.png";